const env = (import.meta.env.MODE === "locally" ? "local" : import.meta.env.MODE) || "local";
const environments = {
  local: {
    apiEndpoint: "http://localhost:3000/waitly-dev/us-central1/",
    db: "waitly-dev",
    googleMapsApiKey: "AIzaSyCA15UnFEC81pSWKWTeiONweQ6bIIR26EQ"
  },
  development: {
    apiEndpoint: "https://us-central1-waitly-dev.cloudfunctions.net/",
    db: "waitly-dev",
    googleMapsApiKey: "AIzaSyCA15UnFEC81pSWKWTeiONweQ6bIIR26EQ"
  },
  production: {
    apiEndpoint: "https://us-central1-zentable-60946.cloudfunctions.net/",
    db: "waitly",
    googleMapsApiKey: "AIzaSyCTJLBsP9q-l5taAXB-6kFALXrmJXNPYaQ"
  }
};

export const environment = environments[env] || environments.development;
